import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@cnx-saas/react-auth';

export const Logout: React.FunctionComponent = () => {
  const { logout } = useAuth(true);
  const navigate = useNavigate();

  useEffect(() => {
    void logout();
    navigate(0); //remove when all frontend apps will not use getAuthState
  });

  return <Navigate to={'/login'} />;
};
